import { Component, State, Prop, Listen, Event, EventEmitter, h, forceUpdate } from '@stencil/core';
// import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';

interface Wizard {
  existingAnswers: any[];
}

@Component({
  tag: 'fdi-wizards',
  styleUrl: 'fdi-wizards.scss',
  shadow: true,
})
export class FdiWizards {

  @Prop() __wizards: string; // similar to the prop for fdi-wizard but an array
  @Prop() __displayFields: string;
  @Prop() __title: string;
  @Prop() __templateId: string;

  @State() id: string;
  @State() wizards: any;
  @State() displayFields: string[];
  @State() activeWizard: Wizard | null;

  @Event({
    eventName: 'fdi_wc_wizardsComplete',
    bubbles: true,
    cancelable: true,
  }) wizardsComplete: EventEmitter
  finish(){
    this.wizardsComplete.emit({
      wizards: this.wizards,
    });
  }

  @Listen('fdi_wc_wizardCompleted')
  fdi_wc_input_change__handler( ev ){
    const {detail} = ev;
    console.log({detail})
    if ( detail.master === this.id ) {
      const currentWizard = this.wizards.get( detail.wizardId );
      if (  currentWizard ) {
        currentWizard.existingAnswers = detail.formatted_answers;
        this.cancelWizard();
      }
    }
  }

  async componentWillLoad() {
    this.id = uuidv4();
    if ( this.__wizards ){
      this.wizards = new Map();
      const temp = JSON.parse( this.__wizards );
      temp.forEach( wizard => {
        this.wizards.set( uuidv4(), wizard );
      });
    } 
    if ( this.__displayFields ) {
      this.displayFields = JSON.parse( this.__displayFields );
    }
  }

  openWizard( key ) {
    if ( !this.activeWizard ) {
      this.activeWizard = key;
    }
  }

  cancelWizard() {
    if ( this.activeWizard ) {
      this.activeWizard = null;
    }
  }

  removeWizard( key ) {
    this.wizards.delete( key );
    forceUpdate( this );
  }

  addWizard() {
    this.wizards.set( uuidv4(), {
      existingAnswers: {},
    });
    forceUpdate( this );
  }

  render() {
    const displays = [...this.wizards.entries()].map( ([key,wizard]) => {
      const values = this.displayFields.map( field => {
        let value = wizard.existingAnswers[field] || null;
        if ( Array.isArray( value ) ) {
          value = value.join( ',' );
        }
        return (
          <div>{field}: {value}</div>
        );
      }); 
      return (
        <div class="wizards-wizard">
          {values}
          <button onClick={ () => this.openWizard( key ) }>Edit</button>
          <button onClick={ () => this.removeWizard( key ) }>Delete</button>
        </div>
      );
    });
    return (
      <div>
        <h2>{this.__title}</h2>
        {this.activeWizard &&
          <div>
            <fdi-wizard __existing-answers={JSON.stringify( this.wizards.get( this.activeWizard ).existingAnswers )} __master={this.id} __wizard-id={this.activeWizard} __template-id={this.__templateId}  />
            <div>
              <button onClick={ () => this.cancelWizard() }>Cancel</button>
            </div>
          </div>
        }
        {!this.activeWizard && displays}
        {!this.activeWizard && <button onClick={ () => this.addWizard() }>Add New</button>}
        {!this.activeWizard && <button onClick={ () => this.finish() }>Save Changes</button>}
      </div>
    );
  }
}
